import React from "react";
import { TextInput, Button } from "components";
import styles from "./../styles.module.scss";

export default function RoutingDetails({ onClick, details, setDetails }) {
  return (
    <div className={styles.main__container}>
      <TextInput
        label="Route Before"
        placeholder="Route Before"
        name="route_before"
        onChange={setDetails}
        value={details?.route_before}
        type="number"
        min="0"
      />
      <TextInput
        label="Service Duration"
        placeholder="Service Duration"
        name="service_duration"
        onChange={setDetails}
        value={details?.service_duration}
        type="number"
        min="0"
      />
      <TextInput
        label="Open Time"
        placeholder="Open Time"
        name="open_time"
        onChange={setDetails}
        value={details?.open_time}
        type="time"
      />
      <TextInput
        label="Close Time"
        placeholder="Close Time"
        name="close_time"
        onChange={setDetails}
        value={details?.close_time}
        type="time"
      />
      <TextInput
        label="Min Commission"
        placeholder="Min Commission"
        name="min_commission"
        onChange={setDetails}
        value={details?.min_commission}
        type="number"
        min="0"
      />
      <TextInput
        label="Max Commission"
        placeholder="Max Commission"
        name="max_commission"
        onChange={setDetails}
        value={details?.max_commission}
        type="number"
        min="0"
      />
      {/* <TextInput
        label="Amount"
        placeholder="Amount"
        name="amount"
        onChange={setDetails}
        value={details?.amount}
        type="number"
        min="0"
      /> */}

      <div className={styles.btn__container}>
        <Button title="Save" onClick={onClick} />
      </div>
    </div>
  );
}
